import moment from 'moment';
import Popup from 'popup/Popup';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { authIdxReload } from 'redux/action/login';
import { dispensingModuleManager, moduleManager } from 'redux/action/modules';
import { SHA256 } from 'utils/SHA256';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import { delay } from 'utils/utils';
import { UserEditablePopupContainer } from './UserEditablePopup.css.js';

const UserEditablePopup = ({ user, dataReloadFunc, auths, children }) => {
  const history = useHistory();
  const [authLevel, setAuthLevel] = useState(1);
  const [checker, setChecker] = useState(true);
  const { register, handleSubmit, errors, clearErrors } = useForm();
  const dispatch = useDispatch();
  const [popupOpen, setPopupOpen] = useState(null);
  const moduleGroups = useSelector((store) => store.moduleGroups.groups);

  useEffect(() => {
    if (user) {
      const auth = auths.find((x) => x.authIdx === user.authIdx);
      if (auth !== undefined) {
        setAuthLevel(auth.level);
      }
    }
  }, [user, auths]);

  const confirmModule = useCallback(
    (data) => {
      if (!checker) {
        return false;
      }

      setChecker(false);

      const [url, msg, encodeUserPw] =
        user.userIdx === null ? ['/api/user/insertData', '등록', SHA256(data.userPw)] : ['/api/user/updateData', '수정', user.userPw];

      customAxiosPostFunction(history, url, { ...data, userModuleScn: '0', userIdx: user.userIdx, userPw: encodeUserPw, rgstDt: moment().format('YYYY-MM-DDTHH:mm:ssZ') })
        .then((response) => {
          console.log(user)
          if (response !== null && response !== 0) {
            dispatch(authIdxReload());
            delay(2000).then(() => {
              dispatch(dispensingModuleManager(Number(data.authIdx)));
              dispatch(moduleManager(Number(data.authIdx)));
              alert(`${msg}완료`);
              setPopupOpen(false);
              dataReloadFunc();
            });
          } else {
            alert(`${msg}실패`);
          }

          setChecker(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    [user, checker]
  );

  return (
    <Popup
      trigger={children}
      modal
      open={popupOpen}
      onOpen={() => {
        setPopupOpen(true);
      }}
      onClose={() => {
        clearErrors();
      }}
    >
      {user && (
        <form onSubmit={handleSubmit(confirmModule)}>
          <UserEditablePopupContainer checker={checker}>
            <div>
              <div>
                <p>아이디</p>
                <input type="text" name="userId" ref={register({ required: true, maxLength: 20 })} defaultValue={user.userId} />
              </div>
              <div className="error-box">{errors.userId && '올바른 아이디를 입력해주세요'}</div>
            </div>
            <div>
              <div>
                <p>비밀번호</p>
                <input
                  type="password"
                  name="userPw"
                  ref={register({
                    required: true,
                    minLength: 8,
                    maxLength: 15,
                    pattern: /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/,
                  })}
                  defaultValue={user.userPw !== '' ? '11aa*******!!' : ''}
                  readOnly={user.userPw !== ''}
                />
              </div>
              <div className="error-box">{errors.userPw && '비밀번호는 숫자, 영어, 특수문자를 포함한 8~15자리로 입력해주세요'}</div>
            </div>
            <div>
              <div>
                <p>부서</p>
                <input type="text" name="dept" ref={register} defaultValue={user.dept} />
              </div>
            </div>
            <div>
              <div>
                <p>이름</p>
                <input type="text" name="userNm" ref={register({ required: true, maxLength: 10 })} defaultValue={user.userNm} />
              </div>
              <div className="error-box">{errors.userNm && '이름을 입력해주세요'}</div>
            </div>
            <div>
              <div>
                <p>연락처</p>
                <input type="text" name="tel" ref={register({ required: true, minLength: 13, maxLength: 13 })} defaultValue={user.tel} />
              </div>
              <div className="error-box">{errors.tel && '연락처를 입력하세요. ex) 010-4790-0520 '}</div>
            </div>
            <div>
              <div>
                <p>수신여부</p>
                <select name="smsFlag" ref={register({ required: true })} defaultValue={user.smsFlag}>
                    <option value={1} label="예"></option>
                    <option value={0} label="아니오"></option>
                </select>
              </div>
            </div>
            <div>
              <div>
                <p>장치그룹</p>
                <select name="moduleGroupIdx" ref={register({ required: true })} defaultValue={user.moduleGroupIdx || ''}>
                  {moduleGroups.map((moduleGroup) => {
                    return <option value={moduleGroup.moduleGroupIdx}>{moduleGroup.moduleGroupIdx}</option>;
                  })}
                </select>
              </div>
            </div>
            <div>
              <div>
                <p>권한</p>
                <div>
                  <select
                    defaultValue={authLevel}
                    onChange={({ target }) => {
                      setAuthLevel(Number(target.value));
                    }}
                  >
                    <option value={1}>슈퍼관리자</option>
                    <option value={2}>안전관리자</option>
                    <option value={3}>공장관리자</option>
                    <option value={4}>공장내부관리자</option>
                  </select>
                  <select name="authIdx" ref={register} defaultValue={user.authIdx}>
                    {auths &&
                      auths
                        .filter((auth) => auth.level === authLevel)
                        .map((auth) => {
                          return (
                            <option key={auth.authIdx} value={auth.authIdx}>
                              {auth.authNm}
                            </option>
                          );
                        })}
                  </select>
                </div>
              </div>
            </div>
            <button type="submit">{user.length === 0 ? '등록' : '수정'}</button>
          </UserEditablePopupContainer>
        </form>
      )}
    </Popup>
  );
};

export default UserEditablePopup;
